import { Input, Spinner, Text, Title } from "../../uikit";
import Header from "../Header";
import Copy from "../../img/copy.svg";
import LinkOut from "../../img/linkout.svg";
import styles from "./login.module.css";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { DOMAIN, TELEGRAM_BOT_LINK, TELEGRAM_BOT_NAME } from "../../consts";
import getMiniappInitData, {
  getTelegramTargetPath,
  markTelegramAutoLoginHandled,
} from "../../telegramMiniapp";
import { AnimatePresence, motion } from "motion/react";
import { useNavigate } from "react-router";
import { opacityVariants } from "../../routesVariants";
import Icon from "components/Icon";
import { saveToken } from "../../utils/tokenStorage";
import trackAdOpen from "../../utils/adUtm";
import trackUmamiEvent from "../../utils/umami";

let timeouts = [];

export default function LoginTelegram({ setVariant = () => {} }) {
  const timeoutInMs = 1000;

  const { t, _ } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [code, setCode] = useState("");
  const navigate = useNavigate();
  const [timeoutCounter, setTimeoutCounter] = useState(0);
  const [secondsCounter, setSecondsCounter] = useState(5);

  const checkTelegramLogin = async () => {
    setIsLoading(true);
    setCode("");
    try {
      const initDataRaw = getMiniappInitData();
      if (initDataRaw?.tgWebAppData) {
        const result = await fetch(DOMAIN + "/auth/telegram", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ initDataRaw }),
        }).then((r) => r.json());
        if (result.success) {
          if (result.is_new_user) {
            trackUmamiEvent("Signup", { method: "telegram" });
          }
          markTelegramAutoLoginHandled();
          saveToken(result.token);
          trackAdOpen();
          // replace: экран логина не должен оставаться в истории,
          // иначе «Назад» с целевого экрана вернёт на логин
          navigate(getTelegramTargetPath() ?? "/account", { replace: true });
          return;
        }
      }
    } catch {
      console.log("backend is down");
    }

    try {
      const result = await fetch(DOMAIN + "/auth/telegram/code", {
        method: "POST",
      }).then((r) => r.json());
      if (result.success) {
        setCode(result.code);
        setTimeoutCounter(500);
        setIsLoading(false);
        return;
      }
    } catch {}

    navigate("/login");
  };

  const checkCode = async () => {
    timeouts.forEach((x) => clearTimeout(x));
    if (secondsCounter != 0) {
      setTimeoutCounter(timeoutCounter - 1);
      setSecondsCounter(secondsCounter - 1);
      return;
    }
    setSecondsCounter(5);

    try {
      const result = await fetch(DOMAIN + "/auth/telegram/verify", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          code,
          lang: localStorage.getItem("lang") || "ru",
        }),
      }).then((r) => r.json());
      if (result.success) {
        if (result.is_new_user) {
          trackUmamiEvent("Signup", { method: "telegram" });
        }
        markTelegramAutoLoginHandled();
        saveToken(result.token);
        trackAdOpen();
        navigate(getTelegramTargetPath() ?? "/account", { replace: true });
        return;
      }
    } catch {}

    setTimeoutCounter(timeoutCounter - 1);
  };

  useEffect(() => {
    if (timeoutCounter > 0) {
      timeouts.push(setTimeout(checkCode, timeoutInMs));
    }
  }, [timeoutCounter]);

  useEffect(() => {
    checkTelegramLogin();
  }, []);

  return (
    <>
      <div className="column card wide ">
        <Header
          isBack={true}
          backCallback={() => {
            timeouts.forEach((x) => clearTimeout(x));
            setVariant("start");
          }}
          className="row"
        >
          <Title level="1" weight="3">
            {t("Login")}
          </Title>
        </Header>
        <AnimatePresence exitBeforeEnter>
          <motion.div
            key={isLoading}
            variants={opacityVariants}
            initial="initial"
            animate="final"
            exit="exit"
          >
            {isLoading ? (
              <div className={styles.spinner_center}>
                <Spinner />
              </div>
            ) : (
              <>
                <div className="row center">
                  <Text>
                    {t("Send the following code to our Telegram bot")}
                  </Text>
                </div>
                <div className={styles["telegram-input-row"]}>
                  <div className={styles["telegram-input"]}>
                    <Input
                      header={t("Code")}
                      value={code}
                    />
                  </div>
                  <div
                    onClick={() => {
                      navigator.clipboard.writeText(code);
                    }}
                    className={styles.icon}
                  >
                    <Icon src={Copy} />
                  </div>
                </div>
                <div className={styles["telegram-input-row"]}>
                  <div className={styles["telegram-input"]}>
                    <Input
                      header={t("Telegram bot")}
                      value={TELEGRAM_BOT_NAME}
                    />
                  </div>
                  <div
                    onClick={() => {
                      window.open(TELEGRAM_BOT_LINK, "_blank");
                    }}
                    className={styles.icon}
                  >
                    <Icon src={LinkOut} />
                  </div>
                </div>
                <div className="center mt-1">
                  <Spinner />
                  <div className={styles.counter}>{secondsCounter}</div>
                </div>
              </>
            )}
          </motion.div>
        </AnimatePresence>
      </div>
    </>
  );
}
